import { gql } from '@apollo/client';

export const PUBNUB_LEAVE_CONVERSATIONS = gql`
  mutation PubNubLeaveConversations($conversation_ids: [String!]!) {
    PubNubLeaveConversations(conversation_ids: $conversation_ids) @client
  }
`;
